import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeSwitcherComponent implements OnInit {
  @Input() theme: string;
  @Output() selectThemeClicked = new EventEmitter<string>();
  @Output() closeClicked = new EventEmitter();

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
  }

  selectTheme(theme: string) {
    switch (theme) {
      case 'light-theme': {
        this.selectThemeClicked.emit('dark-theme');
        break;
      }
      case 'dark-theme': {
        this.selectThemeClicked.emit('light-theme');
        break;
      }
    }
  }

  close() {
    this.closeClicked.emit();
  }
}
